import {Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {MenuModifier} from '../_models/menu-modifier';

@Injectable({
    providedIn: 'root'
})
export class MenuModifierService extends BaseService<MenuModifier> {
    destination = 'menu-modifiers';
}
